import storageHelper from './storage'
import i18n from 'i18next'
import firebase from 'firebase/app'

const interceptorsHelper = {
    addInterceptors: (axiosInstance) => {
        // Add a response interceptor
        axiosInstance.interceptors.request.use(
            (config) => {
                try {
                    // The storage should be stringified
                    const token = JSON.parse(storageHelper.getToken())
                    if (token) {
                        config.headers['access-token'] = token
                    }
                } catch (error) {
                    // Perhaps the token is not stringified
                    const token = storageHelper.getToken()
                    if (token) {
                        config.headers['access-token'] = token
                        // eslint-disable-next-line no-console
                        console.info('Old token found, using it as a fallback...')
                    }
                }
                const lng = i18n.language
                lng && (config.headers['accept-language'] = `${lng}_${lng.toUpperCase()}`)

                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )

        // Add a response interceptor
        axiosInstance.interceptors.response.use(
            (response) => {
                //@TODO handle when data is undefined
                const formattedResponse = {
                    status: response?.status,
                    data: response.data.data || response.data,
                    message: response.data.message,
                }
                return formattedResponse
            },
            (error) => {
                if (error.response?.status === 401) {
                    firebase
                        .auth()
                        .signOut()
                        .then(() => window.location.replace('/'))
                }
                const formattedErrorResponse = {
                    status: error.response?.status,
                    data: error.response?.data,
                }
                return Promise.reject(formattedErrorResponse)
            }
        )
    },
}

export default interceptorsHelper
